import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { SearchResultRow } from "../../../features/search/api/search-metadata.types";
import { setPatientInfo } from "../../../entities/patient-stats/patient-info/patient-info.slice";
import { ROUTES } from "../../../system/router/routes";

// eslint-disable-next-line no-unused-vars
export type SearchRowHandler = (row: SearchResultRow) => void;

/**
 * Resolves the `rowAction` id from results metadata to a click handler.
 * Returns undefined for unknown/absent actions (rows are not clickable then).
 */
export const useSearchRowAction = (
  actionId?: string,
): SearchRowHandler | undefined => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useMemo(() => {
    if (actionId === "openPatient") {
      return (row: SearchResultRow) => {
        dispatch(setPatientInfo(row));
        navigate(ROUTES.PATIENT_STATS.replace(":patientID", String(row.id)));
      };
    }
    return undefined;
  }, [actionId, dispatch, navigate]);
};
